import { render, staticRenderFns } from "./webLogin.vue?vue&type=template&id=70ed7db0&scoped=true&"
import script from "./webLogin.vue?vue&type=script&lang=js&"
export * from "./webLogin.vue?vue&type=script&lang=js&"
import style0 from "./webLogin.vue?vue&type=style&index=0&id=70ed7db0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed7db0",
  null
  
)

export default component.exports